import { render } from "./FormBanner.vue?vue&type=template&id=1de90b0a&scoped=true"
import script from "./FormBanner.vue?vue&type=script&lang=js"
export * from "./FormBanner.vue?vue&type=script&lang=js"

import "./FormBanner.vue?vue&type=style&index=0&id=1de90b0a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1de90b0a"

export default script